import BaseService from "@/js/core/BaseService";
import { UserEndpoints } from '@/js/modules/users/utils/Endpoints';

export default class UserService extends BaseService {
    async me() {
        return await this.api().get(UserEndpoints.Me);
    }
}
